import { APITypesV1 } from "@cur8/api-client";
import { DateTime } from "luxon";
import { AuditInformation } from "./AuditInformation";
import { UserURI } from "@cur8/uri";

type AssignmentData =
  | AktiiaMonitorBloodPressureAssignmentData
  | APITypesV1.RefreshConsentAssignment;

export type Assignment<Data extends AssignmentData = AssignmentData> = {
  id: string;
  assignedTo: UserURI | undefined;
  eTag?: string;
  allowedActions: APITypesV1.AssignmentAction[] | undefined;
  finishAt: DateTime;
  startAt: DateTime;
  patientId: string;
  audit: AuditInformation;
  data: Data;
};

export type BloodPressure = {
  systolic?: number;
  diastolic?: number;
};

export type BloodPressureData = {
  measuredAt?: DateTime;
  bloodPressure?: BloodPressure;
};

export type AggregatedBloodPressureData = {
  measuredAt?: DateTime;
  avgDay?: BloodPressure;
  avgNight?: BloodPressure;
  minDay?: BloodPressure;
  maxDay?: BloodPressure;
  minNight?: BloodPressure;
  maxNight?: BloodPressure;
};

export type AktiiaMonitorBloodPressureAssignmentData = {
  $type: "AktiiaMonitorBloodPressureAssignment";
  deviceSerialNumber: string;
  wearableLocation?: APITypesV1.WearableLocation;
  returnAt: DateTime;
  returnedAt?: DateTime;
  returnLocation: APITypesV1.DeviceReturnLocation;
  minCompletedMeasurements: number;
  rawMeasurements: BloodPressureData[];
  measurements: AggregatedBloodPressureData[];
  doctorsNote?: string;
  state: APITypesV1.AssignmentState;
};

export function isAktiiaMonitorBloodPressureAssignment(
  assignment: Assignment
): assignment is Assignment<AktiiaMonitorBloodPressureAssignmentData> {
  return assignment.data.$type === "AktiiaMonitorBloodPressureAssignment";
}
